import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function UserAdmins({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'Users from Luminr Platform'}  email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

